import React from 'react';
import { Card, Col, Row, Form } from 'react-bootstrap';

const ApplicantInfo = (props) => {
    return (
        <Card>
            <Card.Header>
                <Row>
                    <Col>
                        {props.applicant.type}
                    </Col>
                    <Col className='text-end'>
                        <button type="button" className="btn-close" aria-label="Close" onClick={e => props.handleDelete(props.applicant.id)}></button>
                    </Col>
                </Row>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col md={8}>
                        <Form.Group controlId={`age-${props.applicant.id}`}>
                            <Form.Label>Date of birth *</Form.Label>
                            <Form.Control type="date" required onChange={e => props.handleChange(props.applicant.id, 'dateOfBirth', e.target.value)} value={props.applicant.dateOfBirth} />
                        </Form.Group >
                    </Col>
                    <Col md={4}>
                        <Form.Group controlId={`sex-${props.applicant.id}`}>
                            <Form.Label>Sex *</Form.Label>
                            <Form.Check type="radio" required name={`sex-${props.applicant.id}`} id={`male-${props.applicant.id}`} label="Male" checked={props.applicant.sex === 'male'} onChange={() => props.handleChange(props.applicant.id, 'sex', 'male')} />
                            <Form.Check type="radio" required name={`sex-${props.applicant.id}`} id={`female-${props.applicant.id}`} label="Female" checked={props.applicant.sex === 'female'} onChange={() => props.handleChange(props.applicant.id, 'sex', 'female')} />
                        </Form.Group>
                    </Col>
                </Row>
                <Form.Group controlId={`tobacco-${props.applicant.id}`}>
                    <Form.Check type="checkbox" label="Tobacco user" checked={props.applicant.tobacco} onChange={e => props.handleChange(props.applicant.id, 'tobacco', e.target.checked)} />
                </Form.Group>
            </Card.Body>
        </Card>
    )
};

export default ApplicantInfo;
